// extracted by mini-css-extract-plugin
export default {"announcements":"Z_Qy p-2","announcement":"Z_Qz card my-2","announcement--highlighted":"Z_QB","announcement__list-item":"Z_QC py-1","announcement__flag":"Z_QD"};